import * as React from 'react';

import {Button} from '../../button/button';
import {ButtonCard} from '../../card/button-card';
import {StackLegacy} from '../../layout/stack/stack-legacy';

import styles from './integration-card.module.css';

type Props = {
    isSelected: boolean;
    onClick: () => void;
    primaryText: string;
    integrationLogoUrl: string;
    logoStyles?: number;
};

export function IntegrationCard(props: Props) {
    const handleClick = (e: React.SyntheticEvent<any>) => {
        e.stopPropagation();
        props.onClick();
    };

    return (
        <div className={styles['integration-card-wrapper']}>
            <ButtonCard isSelected={props.isSelected} onClick={handleClick}>
                <div className='pad-16 mb-16 full-height full-width border-box'>
                    <img
                        src={props.integrationLogoUrl}
                        alt='logo'
                        // @ts-expect-error
                        style={props.logoStyles ? props.logoStyles : undefined}
                        className={styles.image}
                    />
                    <StackLegacy spacing={8}>
                        <div className={styles['primary-text']}>{props.primaryText}</div>
                        <Button as='div' variant='primary' onClick={handleClick}>
                            Get started
                        </Button>
                    </StackLegacy>
                </div>
            </ButtonCard>
        </div>
    );
}
